/**
 * Retired (hidden) products.
 *
 * These tours must NOT appear in search, category listings, the home page,
 * related products or the XML sitemaps — but their URLs stay alive and
 * 301-redirect to the closest relevant page (the Cancún tours landing),
 * preserving accumulated SEO authority.
 *
 * Client-safe module (no server imports) so both routes and server fns can
 * use it.
 */

/** Bokun product IDs retired on 2026-08-01. */
export const RETIRED_TOUR_IDS = new Set<string>([
  "898516", // Parque de aventuras extremas con ATV sencillo, tirolesas y cenote
  "898503", // Extreme Horses Adventure con ATV compartido, tirolesas y cenote
  "898507", // Aventura en grupo pequeño por 3 cenotes ocultos con cata de tequila
  "829342", // Desde Cancún: Cocina maya de Chichén Itzá
  "829357", // Desde Cancún: Cenote, Tulum y Playa del Carmen
  "832557", // Desde Cancún: Río Lagartos y Las Coloradas
  "1011497", // Cancún sightseeing: El Meco, site letters and shopping
  "833487", // Desde la Riviera: Tulum, Cenote Mariposa y tortugas en Akumal
  "833494", // Desde Cancún: Tulum, Cenote Mariposa y tortugas en Akumal
  "901126", // Extreme Horses Adventure con ATV individual, tirolesas y cenote
]);

/** Where retired product URLs permanently redirect. */
export const RETIRED_REDIRECT_CITY = "cancun";

/** Trailing numeric id of a unified tour slug, e.g. `...-cenote-898516`. */
export function trailingTourId(slug: string): string | null {
  const m = /(\d{4,})$/.exec(slug.trim());
  return m ? m[1] : null;
}

/** True when the slug (or bare id) points at a retired product. */
export function isRetiredTour(slugOrId: string): boolean {
  if (RETIRED_TOUR_IDS.has(slugOrId)) return true;
  const id = trailingTourId(slugOrId);
  return id ? RETIRED_TOUR_IDS.has(id) : false;
}
